import React from 'react'
import './AwardsSection.css'
import line from "../../components/asset/line.svg";

const AwardsSection = ({ id, smallHeadline, lightBg, awards }) => {
    return (
        <>
            <section id={id}
                className={
                    lightBg === "grey"
                        ? "home__hero-section greyBg"
                        : lightBg === "dark"
                            ? "home__hero-section darkBg"
                            : "home__hero-section whiteBg"
                }>
                <div className="layout" id={id}>
                    <div className='award_section'>
                        <h4
                            className="small-heading"
                        >
                            <span>
                                <img src={line} alt="hr-line" />
                            </span>{" "}
                            {smallHeadline}
                        </h4>
                        <div className='award_image_wrapper'>
                            {
                                awards.map(({ id, img, brandName, linkText, linkUrl}) => (
                                    <div className='award_image_box' key={id}>
                                        {/* image */}
                                        <div className='award_image_box-wrapper'>
                                            <a href={linkUrl} target="_blank" rel="noreferrer noopener">
                                                <img src={img} alt={`award ${id}`} />
                                            </a>
                                        </div>
                                        {/* content - link and brand name */}
                                        <div className='award_content'>
                                            <a className="link_url" href={linkUrl} target='_blank' rel="noreferrer noopener">{linkText}</a>
                                            <img src={brandName} alt={`${brandName} award`} />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AwardsSection